import { render, staticRenderFns } from "./StatusList.vue?vue&type=template&id=a8f3c050"
import script from "./StatusList.vue?vue&type=script&lang=js"
export * from "./StatusList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports